import React from 'react'

function MarqueeText() {
  return (
    <div class="marquee-wrap marquee-wrap-inner">
                                <div class="marquee-text" style={{marginTop:'-23px'}}>

                                    <div class="brand-single-box" >
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>Workflow Automation</h3>
                                    </div>

                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>Enterprise IT Management</h3>
                                    </div>

                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>Process Automation</h3>
                                    </div>

                                    <div class="brand-single-box">
                                       <h3 style={{marginRight:'20px', fontSize:'16px'}}>Service delivery</h3>
                                    </div>

                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>User Experience Optimization                                        </h3>
                                    </div>

                                    <div class="brand-single-box"><h3 style={{marginRight:'20px', fontSize:'16px'}}>Agile Implementation</h3>
                                    </div>
                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>Process Standardization
                                        </h3>
                                    </div>
                                    
                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>Workflow Automation</h3>
                                    </div>

                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>Enterprise IT Management</h3>
                                    </div>

                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>Process Automation</h3>
                                    </div>

                                    <div class="brand-single-box">
                                       <h3 style={{marginRight:'20px', fontSize:'16px'}}>Service delivery</h3>
                                    </div>

                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>User Experience Optimization                                        </h3>
                                    </div>

                                    <div class="brand-single-box"><h3>Agile Implementation</h3>
                                    </div>
                                    <div class="brand-single-box">
                                        <h3 style={{marginRight:'20px', fontSize:'16px'}}>Process Standardization
                                        </h3>
                                    </div>
                                    
                                    
  


                                </div>
                            </div>
  )
}

export default MarqueeText